import documentsSidebarMenuActionCreators from "Areas/Sidebar/Documents/redux/actionCreators";
import { getActiveDocumentId, getDocumentsInProgress, getObjects, getObjectsInProgress } from "Areas/Sidebar/Documents/redux/selectors";
import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import documentDetailsActionCreators from "../documentDetails/redux/actionCreators";
import { getFinalReadOnlyMode } from "../documentDetails/redux/getReadOnlyMode";
import Content from "./content";
import actionCreators from "./redux/actionCreators";
import { getContent, getContentChildNodes, getContentMasterNodes, getDetailedPanelOpen, getInProgress, getSelectedNodeIds, getSourceData } from "./redux/selectors";
const canEdit = security.isAllowed([Permissions.DocumentsEdit]);
const mapStateToProps = (state) => {
    var _a, _b;
    return ({
        key: getActiveDocumentId(state),
        documentId: getActiveDocumentId(state),
        sourceData: (_a = getSourceData(state)) === null || _a === void 0 ? void 0 : _a.Content,
        sourceNodes: (_b = getSourceData(state)) === null || _b === void 0 ? void 0 : _b.Nodes,
        data: getContent(state),
        selected: getSelectedNodeIds(state),
        inProgress: getInProgress(state) || getObjectsInProgress(state) || getDocumentsInProgress(state),
        detailedPanelOpen: getDetailedPanelOpen(state),
        documentObjects: getObjects(state),
        canEdit,
        readOnlyMode: getFinalReadOnlyMode(state),
        masterNodes: getContentMasterNodes(state),
        childrenNodes: getContentChildNodes(state)
    });
};
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(documentsSidebarMenuActionCreators.getObjects()),
    onChangeDetailedPanelOpen: (open) => dispatch(actionCreators.setDetailedPanelOpen(open)),
    onGetContentData: (documentId) => {
        dispatch(actionCreators.getContentMasters(documentId));
    },
    onChangeContentData: (documentId, data) => dispatch(actionCreators.updateContentData(documentId, data)),
    onSaveContentData: (documentId, prevData, data) => dispatch(actionCreators.saveDocumentContentData(documentId, prevData, data)),
    onChangeDeleted: (ids) => dispatch(actionCreators.setDeleted(ids)),
    onGetPreview: (largeAttributeId, completed, rejected) => dispatch(documentDetailsActionCreators.getGraphNodeImageContent(largeAttributeId, completed, rejected))
});
export default connect(mapStateToProps, mapDispatchToProps)(Content);
